import { createSelector } from '@ngrx/store';
import { IAnalyticsState, IRemoteXPACPortalState } from '../../utils/interfaces/store.interfaces';

export const selectAnalytics = (state: IRemoteXPACPortalState) => state.analytics;

export const selectAnalyticsPermissions = createSelector(
  selectAnalytics,
  (state: IAnalyticsState) => state.permission
);

export const selectReports = createSelector(
  selectAnalytics,
  (state: IAnalyticsState) => state.reports
);

export const selectRetailerLicense = createSelector(
  selectAnalytics,
  (state: IAnalyticsState) => state.retailerLicense
);

export const selectMatchingStores = createSelector(
  selectAnalytics,
  (state: IAnalyticsState) => state.matchingStores
);

export const selectTimeZones = createSelector(
  selectAnalytics,
  (state: IAnalyticsState) => state.timeZones
);

export const selectReportPreview = createSelector(
  selectAnalytics,
  (state: IAnalyticsState) => state.reportPreview
);

export const selectLocales = createSelector(
  selectAnalytics,
  (state) => state.locales,
);

export const selectAllTierLimits = createSelector(
  selectAnalytics,
  (state) => state.tierLimits,
);

export const selectDemoStatistics = createSelector(
  selectAnalytics,
  (state) => state.demo,
);